import script from "./EmployeesScreen.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeesScreen.vue?vue&type=script&setup=true&lang=js"

import "./EmployeesScreen.vue?vue&type=style&index=0&id=367b5d3d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-367b5d3d"]])

export default __exports__